// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1y-6";
export var headerCell = "_1y-2";
export var loadingStateContent = "_1y-8";
export var rowWrapper = "_1y-4";
export var stickyAggregationCell = "_1y-b";
export var stickyAggregationRow = "_1y-7";
export var stickyColumnCell = "_1y-a";
export var stickyColumnHeaderCell = "_1y-9";
export var table = "_1y-1";
export var virtualRowWrapper = "_1y-5";
export var virtualTableContainer = "_1y-0";
export var white = "_1y-3";